// extracted by mini-css-extract-plugin
export default {"infoItem":"styles_infoItem__XnCk2","message":"styles_message__NCXRX","date":"styles_date__b5jJL"};